import React, { useState, useRef, useEffect } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { Button, Form, Input } from "semantic-ui-react";
import TextEditor from "../../../../components/Admin/NewTextEditor";
import * as yup from "yup";
import { toast } from "react-toastify";

import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Dropzone from "../../../../components/Admin/Dropzone";
import { Field, Label, Container, Content, Title } from "./styled";
import { isAuthAdmin } from "../../../../services/auth";

const EditarQuestao = (props) => {
  const [selectedFile, setSelectedFile] = useState("");
  const description = useRef("");
  const id = props.match.params.id;
  const optionSimulado = [
    { id: 3636, value: "Simulado para certificação PMP I" },
    { id: 8282, value: "Simulado para certificação PMP II" },
    { id: 8285, value: "Simulado PMP I" },
    { id: 8286, value: "Simulado PMP II" }
  ];

  const optionCorreta = [
    { value: "A" },
    { value: "B" },
    { value: "C" },
    { value: "D" },
  ];
  const [questao, setQuestao] = useState({});
  useEffect(() => {
    loadAuth();
    loadQuestao();
  }, []);
  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };
  useEffect(() => {
    setQuestao({ ...questao, enunciado: description.current });
  }, [description.current]);

  const loadQuestao = () => {
    try {
      api
        .get(`/admin/simulado/questao/${id}`)
        .then((res) => setQuestao(res.data))
        .catch((err) => {
          swal("Não foi possível encontrar essa questão", err, "error");
        });
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  };

  const uploadImage = async () => {
    try {
      const inputData = new FormData();

      inputData.append("file", selectedFile);
      inputData.append("path", "imagens-voitto/imagens-blog/meta/ctas");

      const response = await api.post("/upload", inputData);
      const { url } = response.data;

      setQuestao({ ...questao, imagem: url });

      toast.success("A operação foi concluida com sucesso!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (err) {
      toast.error("A operação falhou, verifique o arquivo e tente novamente", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const editar = async () => {
    const questaoValidation = await yup.object().shape({
      id_simulado: yup
        .string("Necessário que informe o simulado")
        .required("Necessário que informe o simulado"),
      enunciado: yup
        .string("Necessário que informe o enunciado")
        .required("Necessário que informe o enunciado"),
      imagem: yup.string("Necessário que informe a imagem"),
      // .required("Necessário que informe a imagem"),
      a: yup
        .string("Necessário que informe a alternativa A")
        .required("Necessário que informe a alternativa A"),
      b: yup
        .string("Necessário que informe a alternativa B")
        .required("Necessário que informe a alternativa B"),
      c: yup
        .string("Necessário que informe a alternativa C")
        .required("Necessário que informe a alternativa C"),
      d: yup
        .string("Necessário que informe a alternativa D")
        .required("Necessário que informe a alternativa D"),
      correta: yup
        .string("Necessário que informe a alternativa CORRETA")
        .required("Necessário que informe a alternativa CORRETA"),
    });

    try {
      await questaoValidation.validate(questao, { abortEarly: true });
      api
        .put(`/admin/simulado/questao/${id}`, questao)
        .then(async (res) => {
          let array = {
            local: "Questoes",
            texto: `editou a questao de id=${id}`,
          };
          await api.post("system_logs", { acao: JSON.stringify(array) });
          props.history.push("/admin/questoes");
        })
        .catch((err) => {
          swal("Não foi possível salvar a questão", err, "error");
        });
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  };

  return (
    <>
      <Container>
        <AdminMenu />

        <Content>
          <Title>Editar Questão</Title>

          <Form>
            <Field>
              <Label>Simulado:</Label>
              <select
                name="ativo"
                onChange={(e) =>
                  setQuestao({ ...questao, id_simulado: e.target.value })
                }
                value={questao.id_simulado}
              >
                {optionSimulado.map((opcao) => (
                  <option value={opcao.id}>{opcao.value}</option>
                ))}
              </select>
            </Field>
            <Field>
              <Label>Editor de Texto</Label>
              <TextEditor
                haveFullscreen
                default={questao.enunciado}
                text={description}
              />
            </Field>
            <Form.Group>
              <Form.Field>
                <Dropzone onFileUploaded={setSelectedFile} />
              </Form.Field>
            </Form.Group>
            <Form.Field>
              <Button color="primary" onClick={() => uploadImage()}>
                Subir imagem
              </Button>
            </Form.Field>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Questão A"
                placeholder="Questão A"
                value={questao.a}
                onChange={(e) => {
                  setQuestao({ ...questao, a: e.target.value });
                }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Questão B"
                placeholder="Questão B"
                value={questao.b}
                onChange={(e) => {
                  setQuestao({ ...questao, b: e.target.value });
                }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Questão C"
                placeholder="Questão C"
                value={questao.c}
                onChange={(e) => {
                  setQuestao({ ...questao, c: e.target.value });
                }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Questão D"
                placeholder="Questão D"
                value={questao.d}
                onChange={(e) => {
                  setQuestao({ ...questao, d: e.target.value });
                }}
              />
            </Form.Group>
            <Field>
              <Label>Resposta correta:</Label>
              <select
                name="ativo"
                onChange={(e) =>
                  setQuestao({ ...questao, correta: e.target.value })
                }
                value={questao.correta}
              >
                {optionCorreta.map((opcao) => (
                  <option value={opcao.value}>{opcao.value}</option>
                ))}
              </select>
            </Field>
            <Form.Group>
              <Form.Field control={Button} onClick={() => editar()}>
                Editar
              </Form.Field>
              <Link to="/admin/questoes">
                <Button color="secondary">Cancelar</Button>
              </Link>
            </Form.Group>
          </Form>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(EditarQuestao);
